import React from 'react'

import Link from '../HeaderLink'

import './index.css'

const Consultant = ({imgUrl,title,name,phone,email,btnAsk})=>(
	<div className="consultant">
		<div className="row">
			<div className="col">
				{
					imgUrl && imgUrl ? <div className="img"><img src={imgUrl} alt=""/></div>: ''
				}
			</div>
			<div className="col">
				<div className="title">{title}</div>
				<div className="name">{name}</div>
				{
					phone && phone ? <Link target={phone.target} className="phone" icon="phone" text={phone.caption} url={phone.url} /> : ''
				}
				{
					email && email ? <Link target={email.target} className="email" icon="envelope" text={email.caption} url={email.url} /> : ''
				}
			</div>
			<div className="col">
				{
					btnAsk && btnAsk ? <Link target={btnAsk.target} className="btn btn--small" text={btnAsk.caption} url={btnAsk.url} /> : ''
				}
			</div>
		</div>



	</div>
)

export default Consultant


// WEBPACK FOOTER //
// ./src/Components/Consultant/index.js